<div class="card">
  <div class="card-header card-header-squirrel">
    <h4>Neuer Mandant</h4>
  </div>
  <div class="card-body">
    <div class="row" style="margin-top: 10px;">
      <div class="col-md-10">
        <mat-form-field class="example-full-width" >
          <mat-label>Scope</mat-label>
          <mat-select [(ngModel)]="selectedScope" required (selectionChange)="getTenantsForScope()">
            @for (scope of scopes; track scope) {
              <mat-option [value]="scope">
                <span><b>{{ scope.name }}</b></span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- wpServerUrl: [null, Validators.required],
    wpTenantName: [null, Validators.required],
    wpApiKey: [null, Validators.required], -->


    @if (selectedScope) {
      <form [formGroup]="tenantForm" novalidate>
        @if (!(selectedScope.systemtype === 'WINPLAN')) {
          <div class="row">
            <div class="col-md-12">
              <mat-form-field class="example-full-width">
                <input matInput placeholder="{{this.translate.data['INPUTTENANTNAME'] | translate}}" formControlName="name" required>
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field class="example-full-width">
                <input matInput placeholder="Max. Anzahl Benutzer" formControlName="maxUserCount" required>
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field class="example-full-width">
                <input matInput placeholder="Max. Anzahl Projekte" formControlName="maxProjectCount" required>
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field class="example-full-width">
                <input matInput placeholder="Einladung f. Mitglieder gültig (Tage)" formControlName="maxInvitationValidForDays" required>
              </mat-form-field>
            </div>
          </div>
        }
        @if (selectedScope.systemtype === 'WINPLAN') {
          <div class="row">
            <div class="col-md-12">
              <mat-form-field class="example-full-width">
                <input matInput placeholder="Winplan Server Url" formControlName="wpServerUrl" required>
              </mat-form-field>
            </div>
          </div>
        }
        @if (selectedScope.systemtype === 'WINPLAN') {
          <div class="row">
            <div class="col-md-12">
              <mat-form-field class="example-full-width">
                <input matInput placeholder="Winplan Mandant" formControlName="wpTenantName" required>
              </mat-form-field>
            </div>
          </div>
        }
        @if (selectedScope.systemtype === 'WINPLAN') {
          <div class="row">
            <div class="col-md-12">
              <mat-form-field class="example-full-width">
                <input matInput placeholder="Winplan Api User" formControlName="wpApiUser" required>
              </mat-form-field>
            </div>
          </div>
        }
        @if (selectedScope.systemtype === 'WINPLAN') {
          <div class="row">
            <div class="col-md-12">
              <mat-form-field class="example-full-width">
                <input matInput placeholder="Winplan Api Key" formControlName="wpApiKey" required>
              </mat-form-field>
            </div>
          </div>
        }
        @if (selectedScope.systemtype === 'WINPLAN') {
          <div class="row">
            <div class="col-md-12">
              <mat-form-field class="example-full-width">
                <input matInput placeholder="Winplan API Key Inbound" formControlName="wpApiKeyInbound" required>
              </mat-form-field>
            </div>
          </div>
        }
        <h5>Administrator des Mandanten (E-Mail Adresse):</h5>
        <div class="row" style="margin-top: -20px;">
          <div class="col-md-12">
            @if (!userSelected) {
              <mat-form-field class="example-full-width">
                <!-- <input matInput placeholder="{{this.translate.data['SEARCHUSER'] | translate}}" formControlName="responsibleUser" [matAutocomplete]="auto" (input)="onInput($event)"> -->
                <input matInput placeholder="{{this.translate.data['SEARCHUSER'] | translate}}" formControlName="responsibleUser" [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                  (optionSelected)="optionUserSelected($event)">
                  <!-- <mat-option *ngIf="isLoading" class="is-loading">
                  <mat-spinner diameter="50"></mat-spinner>
                </mat-option> -->
                @if (!isLoading) {
                  @for (user of users; track user) {
                    <mat-option [value]="user">
                      <span><b>{{ user.userName }}</b> - {{ user.email }}</span>
                    </mat-option>
                  }
                }
              </mat-autocomplete>
            </mat-form-field>
          }
          @if (userSelected && selectedUserEmail != '') {
            <a class="a-color">{{selectedUserEmail}}</a>
          }
        </div>
      </div>
    </form>
  }


  @if (showTenantsForScope && selectedScope && selectedScope.systemtype !== 'WINPLAN') {
    <div class="row" >
      <div class="col-md-12">
        <mat-form-field class="example-full-width">
          <mat-label>Mandant für die Auswahl von Vorlagen</mat-label>
          <mat-select [(ngModel)]="selectedTenant">
            @for (tenant of tenants; track tenant) {
              <mat-option [value]="tenant">
                <span><b>{{ tenant.displayName }}</b></span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <!-- <div class="col-md-2">
      <span style="color: red; font-weight: 600"> {{migrationError}}</span>
    </div> -->
  </div>
}

@if (selectedTenant) {
  <mat-slide-toggle [disabled]="false" [checked] = "inclTGR" color="primary" (change)="onChange()">inkl. Mandantengruppen des ausgewählten Mandanten</mat-slide-toggle>
}


@if (selectedScope && selectedScope.systemtype !== 'WINPLAN') {
  <div>
    @if (selectedScope && selectedScope.systemtype !== 'WINPLAN') {
      <mat-slide-toggle [disabled]="false" [checked] = "forSystemTest" color="primary" (change)="onChangeForTest()">Mandanten für Systemtest anlegen</mat-slide-toggle>
    }
    <a>
      <mat-icon
        matTooltip="Wenn der Mandant für Systemtests angelegt wird, kann dieser Mandant und/oder alle zugehörigen Daten später automatisch gelöscht werden."
        matTooltipPosition="right"
        style="cursor: pointer; color: #ff9800;margin-bottom: 8px; margin-left: 5px;">
        warning
      </mat-icon>
    </a>
  </div>
}

<div class="row">
  <a>
    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
    (click)="cancel()" >Abbruch</button>
  </a>
  <span style="flex: 1 1 auto"></span>
  <a>
    @if (selectedScope && selectedScope.systemtype === 'WINPLAN') {
      <button  mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="Mandanten Informationen in die Zwischenablage kopieren"
      (click)="copy()" >Kopieren</button>
    }
  </a>
  @if (selectedScope && (selectedScope.systemtype === 'WINPLAN' || !showTenantsForScope)) {
    <a >
      <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="{{this.translate.data['ADDTENANT'] | translate}}"
      (click)="add()" [disabled]="!isFormValid()" >Hinzufügen</button>
    </a>
  }
  @if (selectedScope && selectedTenant && (selectedScope.systemtype !== 'WINPLAN' && showTenantsForScope)) {
    <a >
      <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="Projektvorlagen auswählen"
      (click)="selectTemplates()" [disabled]="!isFormValid()" >Weiter</button>
    </a>
  }
  @if (selectedScope && (selectedScope.systemtype !== 'WINPLAN' && !selectedTenant)) {
    <a >
      <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="Module auswählen"
      (click)="add()" [disabled]="!isFormValid()" >Weiter</button>
    </a>
  }

</div>
</div>
</div>